"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONSTANTS = void 0;
const CONSTANTS = exports.CONSTANTS = {
  MINESITE_SUBHEAD: "Select a <MineSiteLabel> to view current users and invite your team members",
  VIEW_USERS: "View Users",
  BRDCRUMB_HEAD1: "Manage your team",
  ALL_USERS: 'All Users',
  ACCESS_REQUEST: 'Access Requests',
  MANAGE_TEAM_TITLE: "Manage Your Team",
  BREADCRUMB_MORE_ITEMS_TEXT: 'Click here to see other items',
  BUSINESS_ENTITY: '<MineSiteLabel> (Root)'
};